<script>
import $ from 'jquery'
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import Vue from 'vue'
// import StarRating from 'vue-star-rating'
// import myVideo from 'vue-video'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import * as Cookies from 'js-cookie'
import router from '../router/index'
import momentsone from 'moment-timezone'

const formShape = {
  candidate_name: '',
  candidate_lastname: '',
  candidate_email: '',
  year_of_experience: '',
  month_of_experience: '',
  primarySkils: '',
  secoundarySkills: '',
  comments: '',
  candidate_uniqueid: '',
  candidate_ssn: ''
}
export const EventBus = new Vue()
export default {
  name: 'schedule-details',
  data () {
    return {
      userid: '',
      form: Object.assign({}, formShape),
      base_urls: BaseURLV3,
      profiledetails: [],
      profilesills: [],
      groupeddate: [],
      pSkils: [],
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      primes: [],
      timezone: momentsone.tz.guess(),
      seconds: [],
      postdatas: [],
      // postdetails: [],
      scheduledetail: [],
      sid: [],
      files: [],
      startdate: '',
      enddate: '',
      selectpost: '',
      tabOne: false,
      tabTwo: true,
      validationerror: false,
      emailval_error: false,
      showrole: false,
      rating: 3.5,
      unique_exist: false,
      unique_required: false,
      unique_invalid: false,
      ssn_exist: false,
      ssn_required: false,
      ssn_invalid: false,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      scheduleData: JSON.parse(localStorage.getItem('scheduleData')),
      postdetails: JSON.parse(localStorage.getItem('postData')),
      sections:
      [
        { value: 75, color: '#f39c12' }
      ],
      video: {
        sources: [{
          src: '../assets/video/video.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: true,
          volume: 0.6,
          poster: '../assets/video/video.mp4'
        }
      },
      otheremailList: [],
      otherEmails: ''
    }
  },
  components: {
    // StarRating,
    Multiselect
  },
  props: {
    shwovalueScheduleDetails: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    // axios.get(BaseURLV3 + '/skills/skills/ios', this.config).then(response => {
    //   this.pSkils = response.data.all_skill
    // }).catch(e => {
    // })
  },
  created () {
    this.shwovalueScheduleDetails = true
    // this.posts = JSON.parse(localStorage.getItem('postId'))
    // this.interviewer = JSON.parse(localStorage.getItem('viewid'))
    // this.userid = JSON.parse(localStorage.getItem('viewid'))
    // this.selectpost = JSON.parse(localStorage.getItem('postId'))
    // this.sid = JSON.parse(localStorage.getItem('sid'))
    this.startdate = ''
    this.enddate = ''
    // this.getdata()
    // this.getpostdata()
    // this.getscheduledata()
    // var email = this.userInfo.user_email
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      candidate_name: {
        required
      },
      candidate_lastname: {},
      candidate_email: {
        required, email
      },
      year_of_experience: {
      },
      month_of_experience: {
        required
      },
      primarySkils: {
      },
      secoundarySkills: {
      },
      comments: {
      },
      candidate_uniqueid: {

      },
      candidate_ssn: {

      }
    }
  },
  methods: {
    enterEmail () {
      const data = {
        emailid: this.otherEmails
      }
      this.otheremailList.push(data)
      this.otherEmails = ''
    },
    removeEmail (index) {
      this.otheremailList.splice(index, 1)
    },
    getDate (date) {
      // const Start = moment.utc(date)
      const Start = moment.utc(date).tz(this.timezone).format('DD MMM YYYY')
      console.log(Start)
      return Start
    },
    getTime (date) {
      const Start = moment(date).utc().tz(this.timezone).format('hh:mm a')
      return Start
    },
    getEndTime (date) {
      return moment(date).utc().tz(this.timezone).add(1, 'h').format('hh:mm a')
    },
    getavailabledate (id, data) {
      this.$root.$emit('message_reschedule', id, data)
    },
    fileUploads (e) {
      console.log(e.target.files)
      $('.custom-file-uploads').removeClass('is-invalid')
      this.files = []
      for (let k = 0; k < e.target.files.length; k++) {
        console.log(e.target.files[k].type)
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#files').val('')
      console.log(this.files)
    },
    removeUploading (index) {
      this.files.splice(index, 1)
      console.log(this.files)
    },
    uploading (sid) {
      console.log(this.files)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('sid', sid)
      formData.append('candidate_name', this.form.candidate_name)
      if (this.files.length > 0) {
        axios.post(BaseURLV3 + '/dashboard/add_candidate_resume/' + sid + '/' + this.form.candidate_name,
          formData, config).then(response => {
          // window.location.href = '/Dashboard'
        }).catch(e => {
          console.log(e)
        })
      }
    },
    ValidateAlpha (event) {
      // event = (event) ? event : window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        return true
      } else {
        event.preventDefault()
      }
    },
    removeerrorp () {
      this.pskillerror = false
    },
    removeerrors () {
      this.Sskillerror = false
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    SendMessageToParent () {
      this.$root.$emit('message_from_abc', this.selectpost)
      this.$root.$emit('message_from_tobe', this.selectpost)
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0]
      if (el) {
        el.scrollIntoView()
      }
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
      console.log(this.groupeddate)
    },
    getdatetime (start, end) {
      this.validationerror = false
      this.startdate = start
      this.enddate = end
    },
    close () {
      this.$emit('input', false)
    },
    getdata () {
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
        this.profilesills = response.data.profileSkillList
        this.groupBy(response.data.availabilityDetails, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    },
    getpostdata () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.postdetails = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    getscheduledata () {
      const mainurl = '/dashboard/get_schedule_detail/web/' + this.sid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.scheduledetail = response.data.scheduleList[0]
        this.primes = response.data.candidate_primarykills
        this.seconds = response.data.candidate_secondarykills
        this.autodateas()
      }).catch(e => {
        console.log(e)
      })
    },
    autodateas () {
      this.form.candidate_name = this.scheduledetail.candidate_name
      this.form.candidate_lastname = this.scheduledetail.candidate_lastname
      this.form.candidate_uniqueid = this.scheduledetail.candidate_uniqueid
      this.form.candidate_ssn = this.scheduledetail.candidate_ssn
      this.form.candidate_email = this.scheduledetail.candidate_email
      this.form.year_of_experience = this.scheduledetail.year_of_experience
      this.form.month_of_experience = this.scheduledetail.month_of_experience
      this.form.comments = this.scheduledetail.comments
      if (this.scheduledetail.candidate_resume) {
        this.files.push({ name: this.scheduledetail.candidate_name + '_resume.pdf' })
      }
      console.log(this.primes)
      const pdata = []
      const sdata = []
      for (let k = 0; k < this.primes.length; k++) {
        pdata.push({ id: this.primes[k].skill_id, name: this.primes[k].skill_name })
      }
      for (let m = 0; m < this.seconds.length; m++) {
        sdata.push({ id: this.seconds[m].skill_id, name: this.seconds[m].skill_name })
      }
      console.log(pdata)
      this.form.primarySkils = pdata
      this.form.secoundarySkills = sdata
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    onSubmitProfile () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      if (this.showRole) {
        console.log(this.validate())
        this.form.year_of_experience = 0
        this.form.month_of_experience = 0
      }
      if (this.validate()) {
        if (this.profiledetails.user_email === this.form.candidate_email) {
          this.emailval_error = true
          return false
        }
        this.$nextTick(() => {
          this.postdatas = []
          this.postdatas = {
            id: this.scheduledetail._id,
            candidate_name: this.form.candidate_name,
            candidate_lastname: this.form.candidate_lastname,
            candidate_email: this.form.candidate_email,
            year_of_experience: this.form.year_of_experience,
            month_of_experience: this.form.month_of_experience,
            comments: this.form.comments,
            others: this.otheremailList,
            candidate_uniqueid: this.form.candidate_uniqueid,
            candidate_ssn: this.form.candidate_ssn
          }
          let mainurl = ''
          if (this.showRole) {
            mainurl = '/dashboard/edit_candidateinfo_acs'
          } else {
            mainurl = '/dashboard/edit_candidateinfo'
          }
          axios.post(BaseURLV3 + mainurl, {
            formData: this.postdatas
          }, this.config).then(response => {
            const id = response.data.results._id
            this.sid = id
            this.primaryskillsend(id)
            this.secondaryskillsend(id)
            if (this.files.length > 0) {
              this.uploading(id)
            }
            this.getscheduledata()
            this.tabOne = false
            this.tabTwo = true
            this.$awn.success('Updated successfully')
          })
        })
      } else {
        console.log('validation fail................')
      }
    },
    primaryskillsend (id) {
      const postdata = []
      let k = 0
      for (k = 0; k < this.form.primarySkils.length; k++) {
        const data = {
          schedule_id: id,
          candidate_name: this.form.candidate_name,
          skill_id: this.form.primarySkils[k].id,
          skill_name: this.form.primarySkils[k].name
        }
        postdata.push(data)
      }
      console.log(postdata)
      axios.post(BaseURLV3 + '/dashboard/add_schedule_primary_skill/' + id, {
        formData: postdata
      }, this.config).then(response => {
        // let id = response.data
      })
    },
    secondaryskillsend (id) {
      const postdata = []
      let k = 0
      for (k = 0; k < this.form.secoundarySkills.length; k++) {
        const data = {
          schedule_id: id,
          candidate_name: this.form.candidate_name,
          skill_id: this.form.secoundarySkills[k].id,
          skill_name: this.form.secoundarySkills[k].name
        }
        postdata.push(data)
      }
      console.log(postdata)
      axios.post(BaseURLV3 + '/dashboard/add_schedule_secondary_skill/' + id, {
        formData: postdata
      }, this.config).then(response => {
        // let id = response.data
        this.SendMessageToParent()
        this.close()
      })
    },
    rescheduleaccept (id) {
      axios.get(BaseURLV3 + '/dashboard/reschedule_accept/' + id, this.config).then(response => {
        this.getscheduledata()
        this.$root.$emit('message_from_tobe', this.selectpost)
      })
    },
    reschedulecancel (id) {
      console.log('cancel start')
      // localStorage.setItem('reschedule', JSON.stringify('no'))
      localStorage.setItem('sid', JSON.stringify(id))
      this.close()
      this.$root.$emit('message_cancel', this.interviewer, this.selectpost)
    },
    reschedulecancel1 (id, type) {
      if (type === 2) {
        console.log('sdf')
        localStorage.setItem('reschedule', JSON.stringify('decline'))
      } else if (type === 3) {
        localStorage.setItem('reschedule', JSON.stringify('decline1'))
      } else {
        localStorage.setItem('reschedule', JSON.stringify('cancel'))
      }
      console.log('cancel start1')
      // localStorage.setItem('reschedule', JSON.stringify('cancel'))
      localStorage.setItem('sid', JSON.stringify(id))
      this.close()
      this.$root.$emit('message_cancel', this.interviewer, this.selectpost)
    },
    checkingdate (date, end) {
      console.log(date)
      const currentDate = new Date()
      // let scheduledate = moment.utc(date).format('YYYYMMDDHHmm')
      // scheduledate = scheduledate - 5
      var scheduledate = moment(date).subtract(5, 'minutes').toDate()
      scheduledate = moment(scheduledate).utc().format('YYYYMMDDHHmm')
      const endtime = moment.utc(end).format('YYYYMMDDHHmm')
      const currentdate = moment(String(currentDate)).format('YYYYMMDDHHmm')
      console.log(scheduledate)
      console.log(endtime)
      console.log(currentdate)
      if (currentdate >= scheduledate && currentdate < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    connect (id, sid, x) {
      console.log(this.userInfo)
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      localStorage.setItem('job_title', x.job_tittle)
      localStorage.setItem('organization', this.userInfo.organization)
      router.push('/agora/meeting')
    },
    changeEmail () {
      this.emailval_error = false
    },
    fileUploadsNew (e) {
      $('.custom-file-uploads').removeClass('is-invalid')
      this.files = []
      for (let k = 0; k < e.target.files.length; k++) {
        if (this.showRole) {
          if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf') {
            if (e.target.files[k].size < '2000001') {
              this.files.push(e.target.files[k])
              this.filerequire = 0
            }
          }
        } else {
          if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
            if (e.target.files[k].size < '2000001') {
              this.files.push(e.target.files[k])
              this.filerequire = 0
            }
          }
        }
      }
      $('#files').val('')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('sid', 8000000)
      formData.append('candidate_name', 'text')
      if (this.files.length > 0 && this.showRole) {
        axios.post(BaseURLV3 + '/dashboard/add_candidate_resume_new/8000000/text',
          formData, config).then(response => {
          this.form.candidate_email = response.data.email
          this.form.candidate_uniqueid = response.data.candidate_uniqueid
          this.form.candidate_ssn = response.data.candidate_ssn
          if (response.data.details.length > 0) {
            if (response.data.details[0] !== '') {
              this.form.candidate_name = response.data.details[0]
              this.form.candidate_lastname = response.data.details[1]
            } else if (response.data.details[1] !== '') {
              this.form.candidate_name = response.data.details[1]
              this.form.candidate_lastname = response.data.details[2]
            } else {
              this.form.candidate_name = response.data.details[2]
              this.form.candidate_lastname = response.data.details[3]
            }
            if (response.data.candidate_uniqueid.length === 4) {
              this.editoptionssn = true
            }
            if (response.data.candidate_ssn.length === 4) {
              this.editoption = true
            }
            if (this.form.candidate_uniqueid === 'NA' || this.form.candidate_uniqueid === 'Na') {
              this.form.candidate_uniqueid = ''
            }
            if (this.form.candidate_ssn === 'NA' || this.form.candidate_ssn === 'Na') {
              this.form.candidate_ssn = ''
            }
            this.unique_required = false
            this.unique_invalid = false
            this.unique_exist = false
            this.ssn_exist = false
            this.ssn_invalid = false
            this.ssn_required = false
            this.showone = false
          }
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}
</script>

<template>
<!-- <div class="custom-modal-backdrop" v-show="shwovalueScheduleDetails">  -->
  <div class="modal fade1 in" id="modal-default" style="display: block;" v-show="shwovalueScheduleDetails">
  <div class="modal-dialog" style="margin-top:15px">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close">
          <span aria-hidden="true" @click="close()">×</span></button>
        <h4>Schedule</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div >
              <div class="direct-chat-info clearfix">
                <span class="direct-chat-name pull-left">
                  <span style="color:#999;font-weight: 400;font-size:12px">Job Title</span>
                  <span><h5 class="mt-0 mb-7 c-g">{{postdetails.job_title}}</h5></span><br>
                  <span class="skill-title">Skillset</span><br>
                  <span class="skill-value mb-2">{{postdetails.primarySkillName}}</span><br>
                  <span class="skill-title">Interview Type</span><br>
                  <span class="skill-value">{{postdetails.interview_type}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-8 pull-right gray-details p-1">
            <div class="direct-chat-messages">
              <b>Interviewer</b>
              <hr>
              <div class="direct-chat-msg">
                <img v-if="scheduleData.schedule[0].interviewer.candidate.profile_pic !='' && scheduleData.schedule[0].interviewer.candidate.profile_pic !=null" :src="`${scheduleData.schedule[0].interviewer.candidate.profile_pic}`" class="direct-chat-img">
                <!-- <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture !='' && profiledetails.profile_picture !=null" :src="`${profiledetails.profile_picture}`" class="direct-chat-img">
                <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == null" src="../assets/img/default.png" class="direct-chat-img">
                <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'female'" src="../assets/img/female_default.png" class="direct-chat-img">
                <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'male'" src="../assets/img/male_default.png" class="direct-chat-img"> -->
                <div class="direct-chat-info clearfix">
                  <span class="direct-chat-name pull-left ml-5">{{scheduleData.schedule[0].interviewer.candidate.first_name}} {{scheduleData.schedule[0].interviewer.candidate.last_name}}</span><br>
                  <span class="direct-chat-name pull-left ml-5"><span class="skill-title">Designation : </span ><span class="skill-value" :title="scheduleData.schedule[0].interviewer.candidate.designation">{{scheduleData.schedule[0].interviewer.candidate.designation}}</span></span>
                    <!-- <span style="color:#999;font-weight: 400;" class="ml-5">Skillset : <span v-for="(item,i) in profilesills" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.skill_desc}}
                    </span></span> -->
                  <!-- <span class="direct-chat-timestamp pull-right" style="width:25%"><star-rating class="pull-right" style="width:75%" active-color="#5bad2b" :show-rating="false" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(profiledetails.interviewer_rating)" :read-only="true"></star-rating></span> -->
                </div>
                <div class="direct-chat-info clearfix  mt-5">
                  <div>
                    <button v-if="!Boolean(showRole)" class="btn btn-default btn-xs btns pull-left">Experience : {{ scheduleData.schedule[0].interviewer.candidate.year_of_experience }} Years | {{scheduleData.schedule[0].interviewer.currency_symbol}} {{scheduleData.schedule[0].interviewer.interview_cost}} / Interview</button>
                    <div v-if="scheduleData.schedule[0].available_datetime != null">
                      <a style="line-height: 2;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right" v-bind:class="{'sbtn-d': scheduleData.schedule[0].status != 'Scheduled', 'sbtn' : scheduleData.schedule[0].status == 'Scheduled'}"><i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(scheduleData.schedule[0].utc_starttime)}} to {{getEndTime(scheduleData.schedule[0].utc_starttime)}}</a>
                      <div class="pull-right with-date" style="width: 16%;">
                        <span>{{scheduleData.schedule[0].utc_starttime | formatDate}}</span><br>
                        <span>{{scheduleData.schedule[0].utc_starttime | getDay}}</span>
                      </div>
                    </div>
                    <!-- <span class="direct-chat-timestamp pull-right ml-1 wishlist mt-6" style="width: 15%;"><a><i class="fa fa-clock" aria-hidden="true"></i> Reshedule</a></span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="Boolean(tabOne)">
          <hr>
          <div class="col-md-12 ">
            <h4>Assign Candidate</h4>
            <hr>
            <!-- start form -->
            <b-form class="register-form" v-on:submit.prevent="onSubmitProfile" novalidate>
                <div class="form-row" v-if="Boolean(showRole)">
                  <div class="form-group">
                    <label>Resume</label>
                      <div class="custom-file-uploads">
                        <div v-if="files.length < 1" class="show-doc-empty">Upload candidate resume *</div>
                        <div class="show-doc" v-if="files.length > 0">
                          <span class="doc-file pull-left" v-for="x in files.slice(0, 2)" :key="x"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                        </div>
                        <label for="files"><i class="fa fa-upload" aria-hidden="true"></i> Upload </label>
                        <input @change="fileUploadsNew($event)" style="visibility:hidden;" type="file" id="files" name="files"/>
                    </div>
                    <span style="color: #aeaaaa;">Supported format (.pdf,.docx), Size (Max 2MB)</span>
                    <div v-if="filerequire == 1">
                      <p class="login-alert-msg error-content">* Select the file</p>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label v-if="!Boolean(showRole)">Candidate Name</label>
                    <label v-if="Boolean(showRole)">Candidate First Name</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_name.$model" type="text" placeholder="Candidate Name *" :state="chkState('candidate_name')"/>
                    <div v-if="$v.form.candidate_name.$error">
                      <p v-if="!$v.form.candidate_name.required" class="login-alert-msg error-content">* Enter Candidate Name</p>
                    </div>
                  </div>
                  <div class="form-group" v-if="showRole">
                    <label>Candidate Last Name</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_lastname.$model" type="text" placeholder="Candidate Last Name *" :state="chkState('candidate_lastname')"/>
                    <div v-if="$v.form.candidate_lastname.$error">
                      <p v-if="!$v.form.candidate_lastname.required" class="login-alert-msg error-content">* Enter Candidate Last Name</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <b-form-input id="candidate_email" v-model.lazy.trim="$v.form.candidate_email.$model" @keyup="changeEmail()" type="text" placeholder="Candidate Email *" :state="chkState('candidate_email')"/>
                    <div v-if="$v.form.candidate_email.$error && !submitted">
                      <p v-if="!$v.form.candidate_email.required" class="login-alert-msg error-content">* Enter Candidate Email</p>
                      <p v-if="!$v.form.candidate_email.email" class="login-alert-msg error-content">* Enter a valid email</p>
                    </div>
                    <div v-if="emailval_error">
                      <p class="login-alert-msg error-content">* This email already used for interviewer</p>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="showRole">
                  <div class="form-group">
                    <label>Aadhar ( Last 4 digit )</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_uniqueid.$model" type="text" @keyup="changeUnique()" placeholder="Candidate Aadhar" v-bind:class="{'is-invalid': unique_required}"/>
                    <div>
                      <p v-if="showone" class="login-alert-msg error-content">* Please enter either Aadhar or SSN</p>
                      <p v-if="unique_required" class="login-alert-msg error-content">* Enter aadhar number</p>
                      <p v-if="unique_invalid" class="login-alert-msg error-content">* Aadhar should be 4 characters</p>
                      <p v-if="unique_exist" class="login-alert-msg error-content">* Aadhar is already exist.</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>SSN ( Last 4 digit )</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_ssn.$model" type="text" @keyup="changeUnique()" placeholder="Candidate SSN" v-bind:class="{'is-invalid': ssn_required}"/>
                    <div>
                      <!-- <p v-if="ssn_required" class="login-alert-msg error-content">* Enter SSN number</p> -->
                      <p v-if="ssn_invalid" class="login-alert-msg error-content">* SSN should be 4 characters</p>
                      <p v-if="ssn_exist" class="login-alert-msg error-content">* SSN is already exist.</p>
                    </div>
                  </div>
                </div>
                <!-- <div class="form-row">
                  <div class="form-group">
                    <label>Candidate Name</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_name.$model" type="text" placeholder="Candidate Name *" :state="chkState('candidate_name')"/>
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <b-form-input @keyup="changeEmail()" v-model.lazy.trim="$v.form.candidate_email.$model" type="text" placeholder="Candidate Email *" :state="chkState('candidate_email')"/>
                    <div v-if="emailval_error">
                      <p class="login-alert-msg error-content">* This email already used for interviewer</p>
                    </div>
                  </div>
                </div> -->
                <div class="form-row" v-if="!Boolean(showRole)">
                  <div class="form-group">
                    <label>Experience</label>
                    <div class="form-row">
                      <div class="form-group">
                        <div class="form-select">
                          <select v-model="form.year_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                            <option value='' disabled>Select year *</option>
                            <option value="1">1 year</option>
                            <option v-for="x in 19" v-bind:value="x +1" :key="x">{{x + 1}} years</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-select">
                          <select v-model="form.month_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month_of_experience') }">
                            <option value='' disabled>Select month *</option>
                            <option value="0">0 month</option>
                            <option value="1">1 month</option>
                            <option v-for="x in 10" v-bind:value="x +1" :key="x">{{x + 1}} months</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Resume</label>
                      <div class="custom-file-uploads">
                        <div v-if="files.length < 1" class="show-doc-empty">Upload candidate resume *</div>
                        <div class="show-doc" v-if="files.length > 0">
                          <span class="doc-file pull-left" v-for="(x, index) in files.slice(0, 2)" :key="index"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                        </div>
                        <label for="files"><i class="fa fa-upload" aria-hidden="true"></i> Upload </label>
                        <input @change="fileUploads($event)" style="visibility:hidden;" type="file" id="files" name="files"/>
                    </div>
                    <p style="color: #aeaaaa;">Suppported format (.pdf, .doc, .docx), Size (Max 2MB)</p>
                  </div>
                </div>
                <div class="form-row" v-if="!Boolean(showRole)">
                  <div class="form-group">
                    <div class="form-select">
                    <label>Primary skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.primarySkils" v-bind:class="{ 'is-invalid': !chkState('primarySkils') }" placeholder="Select primary skills*" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true"></multiselect>
                  </div>
                  </div>
                  <div class="form-group">
                    <div class="form-select">
                    <label>Secondary skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.secoundarySkills" v-bind:class="{ 'is-invalid': !chkState('secoundarySkills') }" placeholder="Select secondary skills" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true"></multiselect>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="!Boolean(showRole)">
                  <div class="form-group" style="width:100%">
                    <label>Remarks / Comments</label>
                    <!-- <b-form-input v-model.lazy.trim="$v.form.comments.$model" type="text" placeholder="Enter your comments*" :state="chkState('comments')"/> -->
                    <b-form-textarea v-model.lazy.trim="$v.form.comments.$model" :state="chkState('comments')" class="textarea" rows="3" placeholder="Enter your comments"></b-form-textarea>
                  </div>
                </div>
                <div class="form-row" v-if="showRole">
                  <div class="form-group" style="width:100%">
                    <label>Others</label>
                    <b-form-input id="othervalues" v-model="otherEmails" @keyup.enter="enterEmail()" type="email" required placeholder="Type the email and enter"/>
                  </div>
                </div>
                <span v-for="(item,i) in otheremailList" :key="i" class="emaillist">{{item.emailid}} <span @click="removeEmail(i)" style="color: #dd4b39;">X</span></span>
              <hr>
                <div class="form-submit">
                  <a @click="tabOne = false, tabTwo = true" class="mr-11">Back</a>
                  <input type="submit" value="Save" class="submit" name="submit" id="submit" />
                </div>
              </b-form>
            <!-- form end -->
          </div>
        </div>
        <div class="row" v-if="Boolean(tabTwo)">
          <hr>
          <div class="col-md-11" style="left: 4%;background-color: #f5f5f5;border: 1px solid #cccccc73;">
            <div class="row">
              <div class="col-md-6"><h5>Overview</h5> </div>
              <!-- <div class="col-md-6"><a v-if="scheduledetail.status == 'Open' && scheduledetail.reschedule_by ==null" @click="tabTwo = false,tabOne = true" class="pull-right mt-10">Edit candidate info</a></div>     -->
            </div>
            <hr>
            <!-- start form -->
            <div class="row">
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g">Year of Experience</span>
                  <span class="text-title">{{postdetails.year_of_experience}} years {{postdetails.month_of_experience}} month</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Interview Type</span>
                  <span class="text-title">{{postdetails.interview_type}}</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Meeting ID</span>
                  <span class="text-title">{{scheduleData.schedule[0].meeting_id}}</span>
                </div>
              </div>
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g">Primary Skills</span>
                  <span class="text-title">
                    {{postdetails.primarySkillName}}
                    </span>
                </div>
                <!-- <div class="col-md-4">
                  <span class="text-g">Secondary Skills</span>
                  <span class="text-title">
                    {{scheduledetail.secondaryskillnames}}
                  </span>
                </div> -->
                <!-- <div class="col-md-4">
                  <span class="text-g">Job Description</span>
                  <span class="text-title">{{postdetails.org_description}}</span>
                </div> -->
              </div>
              <div class="col-md-12 mb-2">
                <div class="col-md-12">
                  <span class="text-g">Job Description</span>
                  <span class="text-title">{{postdetails.job_comments}}</span>
                </div>
                <div class="col-md-12">
                  <span class="text-g">Comments / Remarks</span>
                  <span class="text-title">{{postdetails.remarks}}</span>
                </div>
              </div>
            </div>
            <!-- form end -->
          </div>
          <hr>
          <div class="col-md-11 mt-10" style="left: 4%;background-color: #f5f5f5;border: 1px solid #cccccc73;">
            <div class="row">
              <div class="col-md-6"><h5>Candidate Info</h5> </div>
              <!-- <div class="col-md-6"><a v-if="scheduledetail.status == 'Open' && scheduledetail.reschedule_by ==null && postdetails.isclient =='no'" @click="tabTwo = false,tabOne = true" class="pull-right mt-10">Edit candidate info</a></div> -->
            </div>
            <hr>
            <!-- start form -->
            <div class="row">
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g" v-if="!showRole">Candidate Name</span>
                  <span class="text-title">{{scheduleData.first_name}}</span>
                </div>
                <div class="col-md-4" v-if="!showRole">
                  <span class="text-g">Year of Experience</span>
                  <span class="text-title">{{scheduleData.year_of_experience}} years {{scheduleData.month_of_experience}} month</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Candidate Email</span>
                  <span class="text-title">{{scheduleData.email}}</span>
                </div>
              </div>
              <div class="col-md-12 mb-2" v-if="!showRole">
                <div class="col-md-4">
                  <span class="text-g">Primary Skills</span>
                  <span class="text-title">
                    <span v-for="(item,i) in primes" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.skill_name}}
                    </span>
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Secondary Skills</span>
                  <span class="text-title">
                    <span v-for="(item,i) in seconds" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.skill_name}}
                    </span>
                  </span>
                </div>
                <!-- <div class="col-md-4">
                  <span class="text-g">Comments / Remarks</span>
                  <span class="text-title">{{scheduledetail.comments}}</span>
                </div> -->
              </div>
            </div>
            <!-- form end -->
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="scheduledetail.reschedule_by =='interviewer' || scheduledetail.reschedule_by =='candidate'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Reschedule</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Request from </span><b>{{scheduledetail.reschedule_by}}</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reschedule_reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reschedule_reason_comments}}</p>
            <!-- <h5>Reschedule request timing</h5>
            <hr>
              <div class="direct-chat-msg">
                <div class="direct-chat-info clearfix">
                  <span class="pull-left mt-5">{{scheduledetail.reschedule_date | formatDate }}</span>
                  <span class="pull-left mt-5 ml-2">{{scheduledetail.reschedule_date | getDay}}</span>
                  <span class="pull-left ml-2">
                    <a v-bind:class="{'sbtn':scheduledetail.reschedule_status == 'Accepted', 'sbtn-d':scheduledetail.reschedule_status == 'Declined', 'sbtn-d':scheduledetail.reschedule_status == 'Cancelled'}" class="button btn-align btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{scheduledetail.reschedule_start_time}} to {{scheduledetail.reschedule_end_time}}</a>
                  </span>
                  <span v-if="scheduledetail.reschedule_status == 'Accepted'" class="direct-chat-timestamp pull-right mt-2" style="color:rgb(96, 171, 47);margin-right: 10px;"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                </div>
              </div> -->
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="scheduledetail.reschedule_by =='organization'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Reschedule</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Requested by </span><b>You</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reschedule_reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reschedule_reason_comments}}</p>
            <h5>Reschedule request timing</h5>
            <hr>
              <div class="direct-chat-msg">
                <div class="direct-chat-info clearfix">
                  <span class="pull-left mt-5">{{scheduledetail.reschedule_date | formatDate }}</span>
                  <span class="pull-left mt-5 ml-2">{{scheduledetail.reschedule_date | getDay}}</span>
                  <span class="pull-left ml-2">
                    <a v-bind:class="{'sbtn':scheduledetail.reschedule_status == 'Accepted', 'sbtn-d':scheduledetail.reschedule_status != 'Accepted'}" class="button btn-align btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{scheduledetail.reschedule_start_time}} to {{scheduledetail.reschedule_end_time}}</a>
                  </span>
                  <span v-if="scheduledetail.reschedule_status == 'Accepted'" class="direct-chat-timestamp pull-right mt-2" style="color:rgb(96, 171, 47);margin-right: 10px;"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                </div>
              </div>
          </div>
          <!-- start -->
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status !=null && scheduledetail.status == 'Declined') && scheduledetail.cancel_by =='organization'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Declined</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Declined by </span><b>You</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status !=null && scheduledetail.status == 'Declined') && (scheduledetail.cancel_by =='interviewer' || scheduledetail.cancel_by =='candidate')">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Declined</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Declined by </span><b>{{scheduledetail.cancel_by}}</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status !=null && scheduledetail.status == 'Cancelled') && scheduledetail.cancel_by =='organization'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Cancellation</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Cancelled by </span><b>You</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status !=null && scheduledetail.status == 'Cancelled') && (scheduledetail.cancel_by =='interviewer' || scheduledetail.cancel_by =='candidate')">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Cancellation</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Cancelled by </span><b>{{scheduledetail.cancel_by}}</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <!-- not reschedule -->
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status ==null && scheduledetail.status == 'Declined') && scheduledetail.cancel_by =='organization'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Declined</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Declined by </span><b>You</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status ==null && scheduledetail.status == 'Declined') && (scheduledetail.cancel_by =='interviewer' || scheduledetail.cancel_by =='candidate')">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Declined</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Declined by </span><b>{{scheduledetail.cancel_by}}</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status == null && scheduledetail.status == 'Cancelled') && scheduledetail.cancel_by =='organization'">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Cancellation</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Cancelled by </span><b>You</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <div class="col-md-11" style="left: 4%;" v-if="(scheduledetail.reschedule_status == null && scheduledetail.status == 'Cancelled') && (scheduledetail.cancel_by =='interviewer' || scheduledetail.cancel_by =='candidate')">
            <div class="direct-chat-info clearfix">
              <h5 class="pull-left">Reason for Cancellation</h5>
              <span class="pull-right" style="margin-top:11px"><span class="text-mute">Cancelled by </span><b>{{scheduledetail.cancel_by}}</b></span>
            </div>
            <hr>
            <p>{{scheduledetail.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{scheduledetail.reason_comments}}</p>
          </div>
          <!-- negative -->
          <div class="col-md-12">
            <hr>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</div>
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
img {
    max-width: 84px;
    height: auto;
}

.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
.nav-tabs {
  border-bottom: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
}
.nav-tabs li {
  width:auto;
}
.nav-tabs li a {
  color:black;
}
.nav-tabs li.active a {
  background-color: #5bad2b;
  color: white;
}
.nav-tabs li.active a:hover {
  background-color: #5bad2b;
  color: white;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.info-box {
  background-color: #f5f5f5 !important;
}
.bg-yellow {
  border-right: 5px solid white;
  background-color: #f5f5f5 !important;
}
.info-box-content {
    padding: 39px 10px;
    margin-left: 90px;
}
.info-box-number {
  font-size: 12px;
}
.resumeview {
  margin-top: 6px;
  margin-right: 20px;
  color: #5bad2b;
}
.f14 {
  font-size: 14px !important;
}
.cg {
  color: #5bad2b;
}
.c {
  text-align: center;
}
tr th {
  text-align: center;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.table>tbody>tr>td {
  padding: 4px;
}
.direct-chat-name.nametext {
  font-size: 14px;
  font-weight: 400;
}
.box-default {
  border: 1px solid #cccccc6e;
}
.box-header.chart {
  background-color: #f5f5f5;
  border: 1px solid #cccccc6e;
}

.button {
  cursor: pointer;
}
.gray-details .direct-chat-messages {
  background-color: #f5f5f5;
  border: 1px solid #cccccc8f;
  overflow: hidden;
  min-height: 130px;
  height: auto;
}
.ml-2 {
  margin-left: 10px;
}
.mt-2 {
    margin-top: 2px !important;
}
.mr-4 {
    margin-right: 4px !important;
}
.mt-4 {
    margin-top: 4px !important;
}
.mt-6 {
    margin-top: 6px !important;
}
.mt-5 {
    margin-top: 5px !important;
}
.mt-0 {
  margin-top: 0px;
}
.mb-7 {
  margin-bottom: -7px !important;
}
.skill-title {
  color: rgb(153, 153, 153);
  font-weight: 400;
  font-size: 12px;
}
.skill-value {
  color: #333;
  font-weight: 400;
  font-size: 14px;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.text-g {
  color: #a29d9d;
}
.text-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
  color: #5B5B5B;
}
.bg-status {
  padding: 4px;
  background-color: #f5f5f5;
}

.custom-file-uploads {
  height: 40px;
  border: 1px solid #e7e7e7;
  opacity: 1;
}
.custom-file-uploads label {
  text-align: center;
  width: 30%;
  float: right;
  margin-top: 2px;
  margin-right: 2px;
  color: white;
  font-weight: 100;
  padding: 7px 2px 7px 0px;
  background-color: #5bad2b;
}
.show-doc {
  width: 68%;
  margin-top: 4px;
  float: left;
  height: 30px;
}
.doc-file {
  background: #F5F5F5 0% 0% no-repeat padding-box;
  border: 1px solid #E0E0E0;
  border-radius: 18px;
  opacity: 1;
  padding: 4px;
  /* display: flex !important; */
  width: 47%;
  margin-left: 2px;
  margin-top: 0px;
}
.doc-name {
  width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.doc-file .fa {
  margin-top: -17px;
  cursor: pointer;
  width: 10%;
  float: right;
  margin-right: 4px;
}
.show-doc-empty {
  width: 60%;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  color: #979797;
}
.custom-file-uploads.is-invalid {
  border: 1px solid red;
}

select .is-invalid {
  border: 1px solid red;
}
.text-title {
  font-weight: 500 !important;
}
.direct-chat-img {
  width: 40px;
  height: 40px;
}
</style>
